var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.01 1H5.28358C2.91922 1 1 2.91922 1 5.28358V12.6248C1 14.9891 2.91922 16.9084 5.28358 16.9084H5.57548V20.7468C5.57548 21.8998 7.00577 22.4398 7.772 21.5714L11.8585 16.9084H19.01C21.3744 16.9084 23.2936 14.9891 23.2936 12.6248V5.28358C23.2936 2.91922 21.3744 1 19.01 1Z",
    stroke: "#102D3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.ecfc088b76bd458c732de3951ddd0759.svg";
export { ForwardRef as ReactComponent };